@if (authReady) {
  <ngx-loading-bar color="#608afa" height="2px" [includeSpinner]="false"></ngx-loading-bar>
  <app-master-title class="app-master-title"></app-master-title>
  <router-outlet></router-outlet>
  <app-growl></app-growl>
}